import 'uni-pages';
import Vue from 'vue'
import Page from './pages/personalCenter/index.vue'
createPage(Page)